@if (commandService.commandInProgress | async) {
  <gbc-loading-spinner class="spinner"></gbc-loading-spinner>
}
<div
  [ngStyle]="{
    display: (commandService.commandInProgress | async) ? 'none' : 'block'
  }"
  >
  <ng-content></ng-content>
</div>
